@if (loadingService.isContentLoading()) {
  <div
    class="absolute inset-0 flex items-center justify-center bg-white/50 dark:bg-gray-950/50 backdrop-blur-xs z-20"
  >
    <div class="flex flex-col items-center gap-4">
      <div class="flex gap-1.5">
        <div
          class="w-3.5 h-3.5 bg-blue-600 rounded-full animate-bounce [animation-delay:-0.3s]"
        ></div>
        <div
          class="w-3.5 h-3.5 bg-blue-600 rounded-full animate-bounce [animation-delay:-0.15s]"
        ></div>
        <div class="w-3.5 h-3.5 bg-blue-600 rounded-full animate-bounce"></div>
      </div>
    </div>
  </div>
}
